<template>
  <!-- Main 3 column grid -->
  <div class="grid grid-cols-1 gap-4 items-start lg:grid-cols-3 lg:gap-8">
    <!-- Left column -->
    <div class="grid grid-cols-1 gap-4 lg:col-span-2">
      <!-- Welcome panel -->
      <section aria-labelledby="profile-overview-title">
        <div class="rounded-lg bg-white overflow-hidden shadow">
          <div class="bg-white p-6">
            <div class="sm:flex sm:items-center sm:justify-between">
              <div class="sm:flex sm:space-x-5">
                <!--                <div class="flex-shrink-0">
                                  <img class="mx-auto h-20 w-20 rounded-full"
                                       :src="this.$store.getters['account/photo']"
                                       alt="">
                                </div>-->
                <span class="inline-flex items-center justify-center h-20 w-20 rounded-full bg-gray-500">
                  <span
                      class="text-3xl font-medium leading-none text-white">{{ user_name[0] }}</span>
                </span>
                <div class="mt-4 text-center sm:mt-0 sm:pt-1 sm:text-left">
                  <p class="text-sm font-medium text-gray-600">Добро пожаловать,</p>
                  <p class="text-xl font-bold text-gray-900 sm:text-2xl"> {{ user_name }} </p>
                  <p class="text-sm font-medium text-gray-600">Администратор</p>
                </div>
              </div>
              <div class="mt-5 flex justify-center sm:mt-0">
                <router-link :to="{name: 'UserProfile', params:{user_id}}"
                             class="flex justify-center items-center px-4 py-2 border border-gray-300 shadow-sm text-sm font-medium rounded-md text-gray-700 bg-white hover:bg-gray-50">
                  Открыть профиль
                </router-link>
              </div>
            </div>
          </div>
          <div
              class="border-t border-gray-200 bg-gray-50 grid grid-cols-1 divide-y divide-gray-200 sm:grid-cols-3 sm:divide-y-0 sm:divide-x">

            <div class="px-6 py-5 text-sm font-medium text-center">
              <span class="text-gray-900">12</span>
              <span class="text-gray-600" @click="push">Vacation days left</span>
            </div>

            <div class="px-6 py-5 text-sm font-medium text-center">
              <span class="text-gray-900">4</span>
              <span class="text-gray-600">Sick days left</span>
            </div>

            <div class="px-6 py-5 text-sm font-medium text-center">
              <span class="text-gray-900">2</span>
              <span class="text-gray-600">Personal days left</span>
            </div>

          </div>
        </div>
      </section>


      <div
          class="rounded-lg bg-gray-200 overflow-hidden shadow divide-y divide-gray-200 sm:divide-y-0 sm:grid sm:grid-cols-2 sm:gap-px">
        <div v-for="(action, actionIdx) in actions" :key="action.title"
             :class="[actionIdx === 0 ? 'rounded-tl-lg rounded-tr-lg sm:rounded-tr-none' : '', actionIdx === 1 ? 'sm:rounded-tr-lg' : '', actionIdx === actions.length - 2 ? 'sm:rounded-bl-lg' : '', actionIdx === actions.length - 1 ? 'rounded-bl-lg rounded-br-lg sm:rounded-bl-none' : '', 'relative group bg-white p-6 focus-within:ring-2 focus-within:ring-inset focus-within:ring-primary-500']">
          <div>
        <span :class="[action.iconBackground, action.iconForeground, 'rounded-lg inline-flex p-3 ring-4 ring-white']">
          <component :is="action.icon" class="h-6 w-6" aria-hidden="true"/>
        </span>
          </div>
          <div class="mt-4">
            <h3 class="text-lg font-medium">
              <router-link :to="action.to" class="focus:outline-none">
                <!-- Extend touch target to entire panel -->
                <span class="absolute inset-0" aria-hidden="true"/>
                {{ action.title }}
              </router-link>
            </h3>
            <p class="mt-2 text-sm text-gray-500">{{ action.description }}</p>
          </div>
          <span class="pointer-events-none absolute top-6 right-6 text-gray-300 group-hover:text-gray-400"
                aria-hidden="true">
        <svg class="h-6 w-6" xmlns="http://www.w3.org/2000/svg" fill="currentColor" viewBox="0 0 24 24">
          <path
              d="M20 4h1a1 1 0 00-1-1v1zm-1 12a1 1 0 102 0h-2zM8 3a1 1 0 000 2V3zM3.293 19.293a1 1 0 101.414 1.414l-1.414-1.414zM19 4v12h2V4h-2zm1-1H8v2h12V3zm-.707.293l-16 16 1.414 1.414 16-16-1.414-1.414z"/>
        </svg>
      </span>
        </div>
      </div>

    </div>

    <!-- Right column -->
    <div class="grid grid-cols-1 gap-4">
      <announcement-col/>
    </div>
  </div>
</template>

<script>
import {mapActions, mapGetters} from 'vuex';
import AnnouncementCol from "@/views/announcements/AnnouncementCol";
import {
  AcademicCapIcon,
  BadgeCheckIcon,
  CashIcon,
  ClockIcon,
  ReceiptRefundIcon,
  UsersIcon,

  NewspaperIcon,
  RssIcon,
  DocumentReportIcon,
  TemplateIcon,
  ServerIcon

} from '@heroicons/vue/outline';


const actions = [
  {
    title: 'Мероприятия',
    description: 'Создание и редактирование мероприятий, модерирование заявок и участников.',
    to: {name: 'EventsAdmin'},
    icon: ClockIcon,
    iconForeground: 'text-teal-700',
    iconBackground: 'bg-teal-50',
  },
  {
    title: 'Пользователи',
    description: 'Список всех зарегистрированных координаторов и администраторов.',
    to: {name: 'Users'},
    icon: UsersIcon,
    iconForeground: 'text-purple-700',
    iconBackground: 'bg-purple-50',
  },
  {
    title: 'Платежи',
    description: 'Статистика и отчеты по платежам, которые совершаются координаторами.',
    to: '#',
    icon: CashIcon,
    iconForeground: 'text-sky-700',
    iconBackground: 'bg-sky-50',
  },
  {
    title: 'Рассылка',
    description: 'Рассылки по электронным адресам координаторов. Выгрузка электронных адресов.',
    to: '#',
    icon: RssIcon,
    iconForeground: 'text-yellow-700',
    iconBackground: 'bg-yellow-50'
  },
  {
    title: 'Отчеты',
    description: ' Итоговые отчеты для выгрузки или печати.',
    to: '#',
    icon: DocumentReportIcon,
    iconForeground: 'text-rose-700',
    iconBackground: 'bg-rose-50',
  },
  {
    title: 'Новости',
    description: 'Создание и редактирование новостей, анонсов и событий.',
    to: '#',
    icon: NewspaperIcon,
    iconForeground: 'text-indigo-700',
    iconBackground: 'bg-indigo-50',
  },
  {
    title: 'Шаблоны',
    description: 'Редактирование частей сайта и системных сообщений.',
    to: '#',
    icon: TemplateIcon,
    iconForeground: 'text-teal-700',
    iconBackground: 'bg-teal-50',
  },
  {
    title: 'Сервер',
    description: 'Информация о состоянии сервера.',
    to: '#',
    icon: ServerIcon,
    iconForeground: 'text-purple-700',
    iconBackground: 'bg-purple-50',
  },
]

export default {
  components: {
    AnnouncementCol, AcademicCapIcon,
    BadgeCheckIcon,
    CashIcon,
    ClockIcon,
    ReceiptRefundIcon,
    UsersIcon,


    NewspaperIcon,
    RssIcon,
    DocumentReportIcon,
    TemplateIcon,
    ServerIcon
  },
  setup() {
    return {actions}
  },
  data: () => ({
    open: false,
    //open: false,
  }),
  methods: {
    ...mapActions('alerts', {pushAlert: 'add'}),

    clickOutside() {
      //console.log(e)
    },
    push() {
      this.$api.auth.check()
      //this.pushAlert({text: 'Тестовый алерт', title: 'Критическая ошибка'})
    }
  },
  computed: {
    ...mapGetters('account', {user_id: 'id', user_name: 'name'}),
  }
}
</script>


<!--
<script>
export default {
  name: 'Home',
  components: {}
}
</script>
-->
